import image6 from '../assets/image6.jpg';

const AboutInfo = () => {
  return (
    <div className="about-info">
    
        <div className="vc-office">
            <h1>Founder's Story - <br /> The Heart Behind Little Sanctum </h1>
            <p>I'm Navya, a Mechanical Engineering graduate from JNTUH, and a former Automobile Design Engineer. Though my corporate path was bright and clear, my heart never skipped away from my passion to work with young children. So, I stepped into the field of Early Childhood Education at Osmania University, eager to understand how little minds learn, grow, and ignite.

I'm a mother of two joyful boys and my journey in education, truly began alongside my son at a renowned Montessori school in Hyderabad. There, I experienced the true wonder of the Montessori method—how it fosters independence, confidence, and a genuine love for learning. That spark led me to pursue my AMI Diploma in the 3-6 age group, deepening my commitment to the Montessori philosophy.

With a decade of experience in this field, I felt called to create a space of my own. And so, in 2025, Little Sanctum Montessori came to life. Our school is more than four walls and a curriculum. It is a warm, peaceful space where children grow with grace—away from screens, surrounded by nature, and in sync with their inner pace.

Along this journey, I also became a certified parenting coach, with a mission to guide and grow a village of parents—where each family uplifts the other, and children blossom under shared love and wisdom. We envision a community where parenting is joyful, not rushed; where childhood is protected, and potential is nourished.

Dr. Maria Montessori called her environment the “House of Children”—a place that feels like a second home, filled with love, safety, and freedom to explore their world. I held onto that dream, and today, I am proud to say Little Sanctum is just that—a cozy, sun-kissed space nestled near nature, where children learn under open skies or inside thoughtfully prepared classrooms.

Come visit us, and feel the heart of this little sanctum—where every child's journey begins with joy and flies out with love for learning</p>
        </div>
        <div className="vc-image">
            <img src={image6} alt="vc-image" />
        </div>
        <br></br>
    
    {/*<div>
       <div className="vc-image">
            <img src={image6} alt="vc-image" />
        </div>
        <div className="vc-office">
            <h1>Office of the <br /> Founder </h1>
            <p>Little sanctum is a warm, thoughtfully designed space led by experienced AMI-trained educators, where your child feels genuinely safe, seen, and 
supported in meeting their unique developmental needs. In this calm, natural, and stress-free environment, little ones are free to explore,
grow, and blossom into their fullest potential- at their own joyful pace..</p>
        </div>
        
    </div>*/}
    </div>
  )
}

export default AboutInfo
